/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/LedgerPaidBy/PaymentMethod/BankAccountPayment/Notes/Content"
  
}) {
let constantData = '('
let paymentNotesValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'notes',
})
let constantData1 = ')'
let aggregateData = fromAggregate.joinNoSpace(constantData, paymentNotesValueData, constantData1)
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 fontStyle="italic"
 data="'('"
 data="payment.notes"
 data="')'"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}